export function Cargando({ texto = 'Cargando…' }: { texto?: string }) {
  return (
    <div
      role="status"
      className="grid min-h-48 place-items-center text-sm text-slate-400"
    >
      {texto}
    </div>
  );
}

export function Aviso({
  tono = 'error',
  children,
}: {
  tono?: 'error' | 'info' | 'exito';
  children: React.ReactNode;
}) {
  const estilo = {
    error: 'bg-red-50 text-red-700 ring-red-200',
    info: 'bg-marca-50 text-marca-800 ring-marca-200',
    exito: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  }[tono];

  return (
    <p role={tono === 'error' ? 'alert' : 'status'} className={`rounded-lg px-4 py-2.5 text-sm ring-1 ${estilo}`}>
      {children}
    </p>
  );
}
